export const LOGIN_WITH_EMAIL = 'auth.login.withEmail';
export const LOGOUT = 'auth.logout';
export const SET_LANGUAGE = 'auth.setLanguage';
